export const testimonials = [
  {
    name: "阳台种豆人",
    tag: "入住 2 年",
    avatar: "豆",
    content:
      "最开始只是随手发了一条养绿植的帖子，没想到认识了一群同好。现在每周都会来生活茶话会冒个泡，比刷短视频踏实多了。",
    likes: 428,
  },
  {
    name: "周一不emo",
    tag: "职场唠嗑常客",
    avatar: "周",
    content:
      "这里的职场版没有阴阳怪气，问问题会有人认真回答。我换工作的很多决定，都是在回帖讨论里想清楚的。",
    likes: 356,
  },
  {
    name: "匿名的橘子",
    tag: "情感树洞",
    avatar: "橘",
    content:
      "在树洞发了最不好意思说的心事，收到的回帖都很温柔。那一刻我就决定留下来了，这里的人真的会好好说话。",
    likes: 512,
  },
  {
    name: "爆米花加倍",
    tag: "追剧党",
    avatar: "爆",
    content:
      "追剧社的氛围特别好，观点不一样也能聊，不剧透这点尤其难得。我现在看完剧第一件事就是来瓜田找讨论。",
    likes: 289,
  },
  {
    name: "厨房小白进化中",
    tag: "美食瓜友",
    avatar: "厨",
    content:
      "从完全不会做饭，到能带一周便当，全靠美食瓜田的瓜友们手把手教。评论区就是一整个免费的厨房课堂。",
    likes: 374,
  },
  {
    name: "晚风半糖",
    tag: "新来的瓜",
    avatar: "晚",
    content:
      "刚来一周，发的第一个帖子就有人回。值班版主还会主动来互动，感觉不是在自言自语，而是真的有人听。",
    likes: 246,
  },
];